import styled from "styled-components";

export const ButtonContainer = styled.div`
  flex-direction: row;
  display: flex;
  width: 100%;
  margin-top: 20px;
  justify-content: space-arround;
`;

export const ButtonWrapper = styled.div`
  margin: 0 5px;
  ${({ flat }) => (flat ? `width: auto; min-width: 70px;` : `width: 100%`)}

  &:first-child {
    margin: 0 5px 0 0;
  }

  &:last-child {
    margin: 0 0 0 5px;
  }
`;
